/**
 * Value class for server sorting, pagination and filtering.
 */
class QueryOptions {

    public orderBy = "";

    public top: number;

    public skip: number;

    public filter = "";

    public quickSearch = "";

    constructor(orderBy: string, top: number, skip: number, filter?: string, quickSearch?: string) {
        this.orderBy = orderBy;
        this.top = top;
        this.skip = skip;

        if (filter !== undefined) {
            this.filter = filter;
        }

        if (quickSearch !== undefined) {
            this.quickSearch = quickSearch;
        }
    }

    public static newUnlimitedFilteredInstance(filter: string) {
        return new QueryOptions("", 1000000, 0, filter);
    }

    public static newQuickSearchInstance(filter: string) {
        return new QueryOptions("", 1000000, 0, filter);
    }

    public toQueryParams(): string {
        const params = new URLSearchParams();

        params.append("$orderby", this.orderBy);
        params.append("$top", String(this.top));
        params.append("$skip", String(this.skip));

        if (this.quickSearch !== "") {
            const qsFilter = `$quickSearch$ ~ '${this.quickSearch}'`;

            if (this.filter !== "") {
                this.filter += ` and ${qsFilter}`;
            } else {
                this.filter = qsFilter;
            }
        }

        if (this.filter !== "") {
            params.append("$filter", this.filter);
        }

        return params.toString();
    }
}

export default QueryOptions;
